import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SetFlagService {
  constructor() {}
  private _sidebarStatus: BehaviorSubject<string> = new BehaviorSubject<string>('');

  updateSideBarStatus(newPageName: string) {
    this._sidebarStatus.next(newPageName);
  }

  get sidebarStatus() {
    return this._sidebarStatus.asObservable();
  }
}
